import { html } from 'lit';
import { Upload } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-upload')
export class PdsIconUpload extends PdsIcon {
  @state()
  icon = Upload;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
